var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlasticOld(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a99a9bdd-b907-41c5-bb95-74cc09b72b91",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 262.06 165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b24b60a0-4925-431f-9c55-8b72d17e3ed3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262.06,
    height: 165,
    rx: 8.58,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b7ba93e5-c9c2-4751-8bfd-16cd1989aeb3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262.06,
    height: 165,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bd0d8853-10ba-42c2-b3b9-e7bd8adc0ecb",
    "data-name": "card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b77905c3-244c-4338-aab4-049209e0a756",
    "data-name": "Group 5886"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b24b60a0-4925-431f-9c55-8b72d17e3ed3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "a4f81d49-7a8f-4a13-9ad2-743099c3270b",
    "data-name": "Group 5885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a233da3e-7031-4348-bff2-73d2453e4922",
    "data-name": "Group 5884"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "a9c08ee6-0dae-4bd2-9d6c-f3bd5b7022de",
    "data-name": "Rectangle 3092",
    width: 262.06,
    height: 165,
    style: {
      fill: "#004292"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "e2eb4f5d-0fcf-49f9-b9c4-8be232895299",
    "data-name": "Group 5874"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b7ba93e5-c9c2-4751-8bfd-16cd1989aeb3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "b75ad88b-6ba2-4980-a460-8c3ad26fbe6a",
    "data-name": "Group 5873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e71641f3-37e6-4a4a-810b-c3ba5b3812d8",
    "data-name": "Group 5872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aab39e78-4ba1-4365-9e3d-528c9b1e5708",
    "data-name": "Path 18222",
    d: "M220,239.25,118.9,66.42,220-106.41,321.05,66.42Z",
    style: {
      fill: "#0b1622"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "bfd8b429-c842-4a63-b571-e450a94c675d",
    "data-name": "Ellipse 1241",
    cx: 87.89,
    cy: 152.51,
    r: 106.35,
    style: {
      fill: "#f9893c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b1c53d2a-1e7d-41e0-93c9-28ed0ea01a56",
    "data-name": "Path 18223",
    d: "M188.85,186A106.47,106.47,0,0,0,126.52,53.4l-7.62,13Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "abf83ee3-f0ac-4b9a-bbf1-9af115e4ab56",
    "data-name": "Group 5875"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b91a4883-8d27-4fad-8706-6b3784009318",
    "data-name": "Path 18224",
    d: "M86.68,64.13a16.36,16.36,0,0,0-1.58-5,4.69,4.69,0,0,0-.52-.86.94.94,0,0,0-1-.06,1,1,0,0,0-.41.71,5.07,5.07,0,0,0,.44,1,13.64,13.64,0,0,1,1.54,6.48,13.88,13.88,0,0,1-1.65,6.73c-.29.54-.33.69-.29.87a1,1,0,0,0,.6.71,1,1,0,0,0,.29,0,.62.62,0,0,1,.19,0c.25,0,.54-.4,1-1.38a16.43,16.43,0,0,0,1.5-5.08A21.21,21.21,0,0,0,86.68,64.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b1d2c305-ada1-4091-bcdf-d2c07523c47f",
    "data-name": "Path 18225",
    d: "M82.64,62.56A12.2,12.2,0,0,0,81.39,60a.92.92,0,0,0-1.25.1c-.27.4-.25.55.21,1.5a9.85,9.85,0,0,1,1.12,4,10.39,10.39,0,0,1-1.06,5.59c-.21.41-.4.83-.44.93a.88.88,0,0,0,.58,1c.6.19,1-.27,1.65-1.71A12.4,12.4,0,0,0,82.64,62.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad4f6631-767a-4989-9d99-404077146535",
    "data-name": "Path 18226",
    d: "M77.6,61.42a.65.65,0,0,0-.57.23c-.4.37-.4.56.09,1.52a7,7,0,0,1,0,6.56c-.3.6-.36.79-.34,1a.88.88,0,0,0,.94.71c.4-.07.58-.27,1-1.06a8,8,0,0,0,.94-3.92,8.33,8.33,0,0,0-.9-3.92C78.31,61.65,78.06,61.42,77.6,61.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ffdfaa40-5380-4869-9720-dc263e3f6cb3",
    "data-name": "Path 18227",
    d: "M74.41,63a.86.86,0,0,0-.69,1h0a3.92,3.92,0,0,0,.29.58,3.67,3.67,0,0,1,0,3.63c-.31.5-.37.71-.29,1a1,1,0,0,0,.5.58c.44.19.85,0,1.23-.6a5.15,5.15,0,0,0,0-5.5C75.08,63.08,74.81,62.92,74.41,63Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "b3cff558-3c04-4b48-aa28-fd360a090efb",
    "data-name": "Rectangle 3093",
    d: "M31.16,51.84H55.91a5.74,5.74,0,0,1,5.74,5.74v16.6a5.75,5.75,0,0,1-5.75,5.75H31.16a5.75,5.75,0,0,1-5.75-5.75V57.58A5.74,5.74,0,0,1,31.16,51.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "f70a731d-8c59-4ea0-bbb9-877138f99767",
    "data-name": "Group 5880"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b5af8a66-1221-4559-aea7-c510fa60cd9e",
    "data-name": "Group 5879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bd15f4d1-3575-404a-9c2b-839db88da53e",
    "data-name": "Group 5877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b78986e9-dc18-4cdc-85f7-e4e220b72da3",
    "data-name": "Group 5876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e8ed1263-5dcc-443c-b154-0e14bf55e5ed",
    "data-name": "Path 18228",
    d: "M211.47,19.29,204,37.16h-4.88L195.4,22.89a2,2,0,0,0-1.1-1.57,19.71,19.71,0,0,0-4.56-1.52l.11-.52h7.87a2.17,2.17,0,0,1,2.13,1.83l2,10.34,4.81-12.17Zm19.14,12c0-4.71-6.52-5-6.47-7.08,0-.64.62-1.32,2-1.5a8.74,8.74,0,0,1,4.56.8l.81-3.79a12.29,12.29,0,0,0-4.33-.79c-4.56,0-7.78,2.43-7.81,5.9,0,2.58,2.3,4,4,4.87s2.4,1.43,2.4,2.22c0,1.2-1.44,1.73-2.77,1.75a9.71,9.71,0,0,1-4.75-1.13l-.83,3.92a14.1,14.1,0,0,0,5.14.94c4.85,0,8-2.4,8.05-6.11m12.06,5.83H247l-3.73-17.87h-3.95a2.12,2.12,0,0,0-2,1.31l-6.93,16.56h4.85l1-2.67h5.93Zm-5.15-6.33L240,24.11l1.4,6.71ZM218.07,19.29l-3.82,17.87h-4.63l3.83-17.87Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "e829d3e3-8242-4ccc-bae1-73ddaaf274e3",
    "data-name": "Group 5878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e5ce86e6-4640-4227-8c1f-257720d600e4",
    "data-name": "Path 18229",
    d: "M218,41.71a9.64,9.64,0,0,1,1.52-.12,2.46,2.46,0,0,1,1.71.51,1.67,1.67,0,0,1,.54,1.28,1.86,1.86,0,0,1-.47,1.31,2.55,2.55,0,0,1-1.87.67,2.72,2.72,0,0,1-.64,0v2.45H218Zm.79,2.95a2.35,2.35,0,0,0,.65.06c1,0,1.54-.47,1.54-1.3s-.58-1.2-1.45-1.2a3,3,0,0,0-.74.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a56f5c82-64a5-423f-8ba8-2282bfc3de49",
    "data-name": "Path 18230",
    d: "M222.88,44.73c0-.51,0-1,0-1.37h.7l0,.87h0a1.34,1.34,0,0,1,1.23-1l.22,0V44l-.27,0a1.1,1.1,0,0,0-1.07,1,2.43,2.43,0,0,0,0,.38v2.34h-.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ee4356fb-8973-4dec-aa13-a56eb7e0a93e",
    "data-name": "Path 18231",
    d: "M226.43,45.71a1.4,1.4,0,0,0,1.27,1.52,1,1,0,0,0,.24,0,2.81,2.81,0,0,0,1.22-.22l.15.57a3.56,3.56,0,0,1-1.47.28,2,2,0,0,1-2.17-1.93,1.5,1.5,0,0,1,0-.3,2.13,2.13,0,0,1,1.88-2.35h.19a2.12,2.12,0,0,1,1.79,2.4v0Zm2.35-.58a1.14,1.14,0,0,0-1-1.28h-.14a1.32,1.32,0,0,0-1.23,1.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e0910338-e7e1-4ada-8075-b538eda79e2c",
    "data-name": "Path 18232",
    d: "M230.77,44.8c0-.57,0-1,0-1.44h.71l.05.76h0a1.71,1.71,0,0,1,1.56-.85A2,2,0,0,1,235,45.36a.66.66,0,0,1,0,.14,2.08,2.08,0,0,1-1.79,2.34l-.22,0a1.53,1.53,0,0,1-1.35-.69h0v2.39h-.79Zm.79,1.17a1.24,1.24,0,0,0,0,.33,1.21,1.21,0,0,0,1.2.93c.84,0,1.33-.69,1.33-1.7s-.46-1.62-1.31-1.62a1.26,1.26,0,0,0-1.21,1,1.64,1.64,0,0,0-.05.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a97c4402-5a26-45c2-ad7c-ebbfeff89d16",
    "data-name": "Path 18233",
    d: "M239.26,46.71a9.24,9.24,0,0,0,.06,1h-.71l-.07-.55h0a1.65,1.65,0,0,1-1.35.65,1.25,1.25,0,0,1-1.34-1.16.34.34,0,0,1,0-.1c0-1.07,1-1.65,2.65-1.64v-.09a.91.91,0,0,0-.78-1h-.22a2.17,2.17,0,0,0-1.16.33l-.18-.54a3,3,0,0,1,1.46-.38c1.34,0,1.67.92,1.67,1.79Zm-.77-1.19c-.87,0-1.87.13-1.87,1a.71.71,0,0,0,.63.76h.12a1.1,1.1,0,0,0,1.08-.74.73.73,0,0,0,0-.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "aadcb144-5412-47ca-9ec1-fdfa3ac0fb0e",
    "data-name": "Path 18234",
    d: "M241.67,42.12a.48.48,0,0,1-.46.5h-.05a.46.46,0,0,1-.48-.45v0a.49.49,0,0,1,.47-.5h0a.49.49,0,0,1,.49.47Zm-.89,5.64v-4.4h.8v4.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b5f18561-4664-43b2-a0e4-87e085544a2b",
    "data-name": "Path 18235",
    d: "M246.93,41.31v5.31c0,.39,0,.84,0,1.14h-.71l0-.76h0a1.58,1.58,0,0,1-1.48.86,2,2,0,0,1-1.9-2.12.49.49,0,0,1,0-.12,2.09,2.09,0,0,1,1.82-2.34h.15a1.5,1.5,0,0,1,1.33.66h0V41.31Zm-.8,3.84a1.84,1.84,0,0,0,0-.33,1.2,1.2,0,0,0-1.16-.92c-.82,0-1.32.73-1.32,1.69s.45,1.63,1.3,1.63a1.23,1.23,0,0,0,1.18-1,2,2,0,0,0,0-.34Z",
    style: {
      fill: "#fff"
    }
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "b077cad6-88b5-46fc-a6b5-44a42a58092b",
    "data-name": " 1234 5678 9-5",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(31 131)",
    style: {
      isolation: "isolate",
      fontSize: 8,
      fill: "#fff",
      fontFamily: "OpenSans, Open Sans"
    }
  }, "Card holder")), /*#__PURE__*/React.createElement("g", {
    id: "f1eea247-ea09-47bd-8283-33d3d5daa9d3",
    "data-name": "Group 30422"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "e90bbea8-682d-4f81-bca9-fadfa4af76d1",
    "data-name": "Ellipse 3168-2",
    cx: 33,
    cy: 102.5,
    r: 3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e0220d16-a240-49dd-91af-d89ae8c8b6b5",
    "data-name": "Ellipse 3169-2",
    cx: 43,
    cy: 102.5,
    r: 3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "b5459551-30e3-4104-b33e-37e47a388865",
    "data-name": "Ellipse 3170-2",
    cx: 53,
    cy: 102.5,
    r: 3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "b839ec25-158e-4d54-a8c5-0005d4cf3896",
    "data-name": "Ellipse 3171-2",
    cx: 63,
    cy: 102.5,
    r: 3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "b5a448ab-d965-4a69-9f18-48153e094292",
    "data-name": "Ellipse 3172-2",
    cx: 87,
    cy: 102.5,
    r: 3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e3077deb-df3f-4179-9fd4-1fe215817555",
    "data-name": "Ellipse 3173-2",
    cx: 97,
    cy: 102.5,
    r: 3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "b32f272e-dd3b-421f-8fd0-4d48472dc8bf",
    "data-name": "Ellipse 3174-2",
    cx: 107,
    cy: 102.5,
    r: 3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "b52bbf14-ccef-423a-947c-a62bd27ac202",
    "data-name": "Ellipse 3175-2",
    cx: 117,
    cy: 102.5,
    r: 3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "fae65ba9-fc5e-4050-aab5-15adf4b23ef2",
    "data-name": "Ellipse 3176-2",
    cx: 146,
    cy: 102.5,
    r: 3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ac3edfe2-46ba-40ac-bbd2-35ae40abc9e9",
    "data-name": "Ellipse 3177-2",
    cx: 156,
    cy: 102.5,
    r: 3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "b2f0720a-61dd-497b-b4e5-5e6e1d3cd5df",
    "data-name": "Ellipse 3178-2",
    cx: 166,
    cy: 102.5,
    r: 3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ab60df7f-e94c-492f-834e-56fe1fad992d",
    "data-name": "Ellipse 3179-2",
    cx: 176,
    cy: 102.5,
    r: 3,
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasticOld);
export default __webpack_public_path__ + "static/media/plastic_old.4751643decbf4336eefb45963c80c67e.svg";
export { ForwardRef as ReactComponent };